<div
  [class]="headerClass()"
  class="flex items-center bg-neutral-50 px-2 gap-1 rounded-t-md border-b border-neutral-100 min-h-[42px]"
>
  <ng-content select="[header]"></ng-content>
</div>
<div class="p-2 grow min-h-0">
  <ng-content></ng-content>
</div>
